import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import { Card, CardBody, Col, Button, ButtonToolbar, Modal } from "reactstrap";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import renderCheckBoxField from "../../../../shared/components/form/CheckBox";
import axios from "axios";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import GoogleLogin from 'react-google-login';
import { jwtDecode } from "jwt-decode";
import { GOOGLE_CLIENT_TOKEN } from '../../../Common/api';
import { addAnalytics } from '../../../Common/analytics';
import microsoft_logo from '../../../../images/Microsoft_logo.svg.png';
//import setAnalytics from '../../../Common/analytics';
//import ReactGA from "react-ga4";


import { withRouter } from 'react-router-dom';

const url = window.location.hostname;
const google = window.google;
// const url='15.206.34.41';
var port = window.location.port;
var portData = window.location.port;
var locationData = [];
var token;

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.onLocation = this.onLocation.bind(this);
    this.state = {
      username: "",
      password: "",
      showPassword: false,
      showUserNameMsg: false,
      showPassMsg: false,
      showLocationUI: false,
      locationNotSelected: false,
      showLoginUi: true,
      selectedLocations: "",
      location_list: [],
      locationModal: false,
      Failedmodal: false,
      pswd_reset: false,
      force_reset:false,
      success_response: false
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  Failedtoggle = () => {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
    if (this.state.success_response == true) {
      this.locationToggle()
    }
  }

  componentWillMount() {
    if (port == 8091) {
      port = "8090";
    } else if (port == 8098) {
      port = "8099";
    } else {
      port = "8088";
    }
  }
  locationToggle = () => {
    this.setState((prevState) => ({ locationModal: !prevState.locationModal }));
  }

  handleChange = (e) => {
    this.setState({
      username: e.target.value,
    });
  };

  handleChange1 = (e) => {
    this.setState({
      password: e.target.value,
    });
  };

  changeLocation = (e) => {
    this.setState({
      locationNotSelected: false,
      selectedLocations: e.target.value,
    });
  };

  createCookie = (cookieName, cookieValue, daysToExpire) => {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  };

  deleteCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };





  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }
  onLocation() {
    if (this.state.selectedLocations === "" || this.state.selectedLocations === undefined || this.state.selectedLocations === null) {
      this.setState({
        locationNotSelected: true
      });

      return false;
    }

    const payload = {
      location: this.state.selectedLocations,
    };

    API.post('/auth/users/location/activate', { param: payload })
      .then((response) => {
        addAnalytics('Login', 'Location Selection', this.state.selectedLocations);
        token = this.accessCookie("token") + ":" + this.state.selectedLocations;
        this.createCookie("token", token);
        this.createCookie("selectedLocation", this.state.selectedLocations);
        this.createCookie("direct_putaway_flag", response.data.direct_putaway);
        this.createCookie("receiving_app_flag", response.data.receiving_app);
        this.createCookie("picking_app_flag", response.data.picking_app);
        this.createCookie("is_mrsl", response.data.is_mrsl);
        this.createCookie("emp_role", response.data.emp_role);
        this.createCookie("virtual_bins", response.data.virtual_bins);
        this.createCookie("userMenu", response.data.userMenu);
        this.createCookie("tezz_warehouse", response.data.tezz_warehouse)

        window.location.href = window.location.protocol + "//" + url + ":" + portData + "/dashboard_default";
      }).catch(function (error) { });
  }

  _handleKeyDown(e) {
    if (e.key === "Enter") {
      this.onLogin();
    }
  }

  _handleKeyDown1(e) {
    if (e.key === "Enter") {
      this.onLocation();
    }
  }



  validateGoogleLogin = async (googleResponse) => {
    try {
      this.setState({ showLoading: true });

      //console.log("credential",googleResponse.credential)

      const payload = {
        tokenId: googleResponse.credential,
        email: googleResponse.decoded.email,
      };

      API.post('/auth/oauth2/googlelogin', { param: payload })
        .then((response) => {

          console.log(response);

          if (response.data.success == false) {
            this.setState({
              Failedmodal: true,
              failed_message: response.data.message,
            })

          } else {
            if (response.data.empRoles[0] == "mis") {

              this.deleteCookie("selectedLocation");
              token = response.data.token;
              this.createCookie("token", token);
              this.createCookie("userName", response.data.userName);
              this.createCookie("userLocations", "");
              this.createCookie("userMenu", response.data.userMenu);
              this.createCookie("invOwner", response.data.invOwner);

              window.location.href = "http://" + url + ":" + portData + "/dashboard_mis";

            } else {
              this.deleteCookie("selectedLocation");
              token = response.data.token;
              this.createCookie("token", token);
              this.createCookie("userName", response.data.userName);
              this.createCookie("userLocations", response.data.userLocations);
              //this.createCookie("userMenu", response.data.userMenu);
              this.createCookie("invOwner", response.data.invOwner);

              locationData = response.data.userLocations.split("$$##!");
              this.locationToggle();
              this.setState({

                location_list: locationData,
              });
            }
          }
        })
        .catch(function (error) { });
    } catch (err) {
      this.setState({ showLoading: false });
      this.toast.error("Your email ID is not registered with Jarvis. Please reach out to Techops team for new ID creation.");
    }
  };

  onGoogleLoginSuccess = (response) => {
    try {
      localStorage.setItem('GoogleTokenId', response.credential);
      const decoded = jwtDecode(response.credential);
      localStorage.setItem('GoogleMailId', decoded.email);
      localStorage.setItem('GoogleName', decoded.name);
      console.log(decoded.email, decoded.name)
      if (decoded.email.endsWith('@lynk.co.in')) {
        //console.log("validate");
        this.validateGoogleLogin({ ...response, decoded });
      }
    } catch (err) {
      this.onGoogleLoginFailure(err);
    }
  };

  onGoogleLoginFailure = (error) => {
    console.log(error)
    addAnalytics("Login", "Google Login Failed", JSON.stringify(error))
    //setAnalytics('no username', window.location.pathname);
    this.toast.error("Google Login Failed. Try again later")
  };

  responseGoogle = (response) => {
    if (response.error) {
      console.error('Google authentication failed:', response.error);
    } else {
      console.log('Google authentication successful:', response);

    }
  };


  onLogin() {
    if (this.state.username === "") {
      this.setState({
        showUserNameMsg: true,
      });
    } else if (this.state.password === "") {
      this.setState({
        showPassMsg: true,
      });
    } else {
      addAnalytics('Login', 'Password Login')
      const payload = {
        username: this.state.username,
        password: this.state.password,
      };

      API.post('/auth/oauth2/user/login', { param: payload })
        .then((response) => {

          if (response.data && response.data.failure_response && Object.keys(response.data.failure_response).length > 0) {
            if (response.data.failure_response.pswd_reset == true|| response.data.failure_response.force_reset == true){
              this.createCookie("password_reset", true);
            }
            this.setState({
              Failedmodal: true,
              failed_message: response.data.failure_response.message,
              pswd_reset: response.data.failure_response.pswd_reset,
              force_reset: response.data.failure_response.force_reset,
              success_response: false
            });

          }
          if (response.data && response.data.success_response && Object.keys(response.data.success_response).length > 0) {
            if (response.data.success_response.empRoles[0] == "mis") {
              this.deleteCookie("selectedLocation");
              token = response.data.success_response.token;
              this.createCookie("token", token);
              this.createCookie("userName", response.data.success_response.userName);
              this.createCookie("userLocations", "");
              this.createCookie("userMenu", response.data.success_response.userMenu);
              this.createCookie("invOwner", response.data.success_response.invOwner);

              window.location.href = window.location.protocol + "//" + url + ":" + portData + "/dashboard_mis";
            } else {
              this.deleteCookie("selectedLocation");
              token = response.data.success_response.token;
              this.createCookie("token", token);
              this.createCookie("userName", response.data.success_response.userName);
              this.createCookie("userLocations", response.data.success_response.userLocations);
              this.createCookie("invOwner", response.data.success_response.invOwner);
              locationData = response.data.success_response.userLocations.split("$$##!");
              this.setState({
                location_list: locationData,
                success_response: true
              });
              if (response.data && response.data.failure_response && Object.keys(response.data.failure_response).length === 0) {
                this.locationToggle();
              }

            }
          }
        }).catch(function (error) { });
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const { showPassword, locationModal, Failedmodal } = this.state;

    return (
      <div>
      <form style={{width: '100%', margin: 'auto', marginTop: '6%'}} className="form" onSubmit={handleSubmit}>
        {this.state.showLoginUi && (
          <div style={{marginLeft: 10}}>
            <div className="form__form-group">
             <div>
              {/*<div id='signInDiv' className='signInDiv'></div>
                   
                <div className='space-between'>(For All Lynk Users)</div>
                
               </div>


              <div className= 'space-between'>
                <span style={{fontWeight: 'bold', fontSize: 16}}>OR </span>
              </div>
            <div>*/}
            <img
                    src={require("../../../../images/User_name.svg")}
                    style={{ width: '21%', marginBottom: 14, marginLeft: '12%' }}
                  ></img>
                </div>


                <div
                  className="form__form-group-field"
                  style={{ marginLeft: "40px" }}
                >

                  <Field
                    name="username"
                    component="input"
                    type="text"
                    value={this.state.username}
                    onChange={this.handleChange}
                    placeholder="Username"
                    style={{ borderRightWidth: 0, height: 44, width: 290 }}
                  />
                  <div className="form__form-group-icon" style={{ borderWidth: 1, backgroundColor: '#fff', borderLeftWidth: 0, height: 38, borderColor: '#ccc' }}>

                    <img
                      src={require("../../../../images/user.svg")}
                      style={{ width: "20px", height: "20px" }}
                    ></img>
                  </div>
                </div>
                {this.state.showUserNameMsg && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "36px" }}>
                      Incorrect Username!
                    </h5>
                  </div>
                )}
              </div>
              <div className="form__form-group" style={{ marginTop: 25 }}>
                <div>
                  <img
                    src={require("../../../../images/password.svg")}
                    style={{ width: '20%', marginBottom: 14, marginLeft: '12%' }}
                  ></img>
                </div>
                <div
                  className="form__form-group-field"
                  style={{ marginLeft: "40px" }}
                >
                  <Field
                    name="password"
                    component="input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={this.state.password}
                    onChange={this.handleChange1}
                    onKeyDown={(e) => this._handleKeyDown(e)}
                    style={{ borderRightWidth: 0, height: 44, width: 290 }}
                  />
                  <div className="form__form-group-icon" style={{ borderWidth: 1, backgroundColor: '#fff', borderLeftWidth: 0, height: 38, borderColor: '#ccc' }}>

                    <img
                      src={require("../../../../images/eye.svg")}
                      style={{ width: "20px", height: "20px", cursor: 'pointer' }}
                      onClick={(e) => this.showPassword(e)}
                    ></img>
                  </div>
                </div>
                {this.state.showPassMsg && (
                  <div>
                    <h5 style={{ color: "red", marginLeft: "36px" }}>
                      Incorrect Password!!
                    </h5>
                  </div>
                )}
              </div>
              <div
                className="account__btns"
                style={{ marginTop: 35, marginLeft: 40 }}
              >
                <Button
                  className="btn-lg button_enable "

                  onClick={this.onLogin}
                >
                  Login
                </Button>
              </div>


            </div>


          )}
          {this.state.showLocationUI && (
            <div>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <img
                      src={require("../../../../images/location.png")}
                      style={{ width: "20px", height: "20px" }}
                    ></img>
                  </div>
                  <div className="form__form-group-field">
                    <select
                      className="form-control select_style"
                      style={{ fontSize: 13, width: 290 }}
                      onChange={this.changeLocation}
                      onKeyDown={(e) => this._handleKeyDown1(e)}
                    >
                      <option value="">Select Location</option>
                      {this.state.location_list &&
                        this.state.location_list.length > 0 &&
                        this.state.location_list.map((location_list) => {
                          return (
                            <option value={location_list}>
                              {" "}
                              {location_list}
                            </option>
                          );
                        })}
                    </select>

                  </div>

                </div>
                {this.state.locationNotSelected &&
                  <span style={{ color: 'red', fontSize: 12 }}> Please select location </span>
                }
                <div
                  className="account__btns"
                  style={{ marginTop: 10, marginLeft: 120 }}
                >
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      marginLeft: "30px",
                      backgroundColor: "#333333",
                      color: "#fbbb00",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    onClick={this.onLocation}
                  >
                    Proceed
                  </Button>
                </div>
              </div>
            </div>
          )}
        </form>

        <Modal isOpen={locationModal} toggle={this.locationToggle}>
          <div className="modal__header">
            <button
              className="fa fa-times modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.locationToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <div>
              <img
                src={require("../../../../images/login_map.svg")}
                style={{ width: "40%" }}
              ></img>
            </div>

            <div className="form__form-group-field" style={{ marginTop: 20, flexDirection: 'column' }}>
              <div style={{ width: '78%', margin: 'auto', textAlign: 'left' }}>
                <label style={{ textAlign: 'left' }}> Choose a location </label>
              </div>
              <div>
                <select
                  className="form-control select_style"
                  style={{ fontSize: 13, width: 300, height: 40 }}
                  onChange={this.changeLocation}
                  onKeyDown={(e) => this._handleKeyDown1(e)}
                >
                  <option value="">Select Location</option>
                  {this.state.location_list &&
                    this.state.location_list.length > 0 &&
                    this.state.location_list.map((location_list) => {
                      return (
                        <option value={location_list}>
                          {" "}
                          {location_list}
                        </option>
                      );
                    })}
                </select>
              </div>

            </div>


          </div>
          <ButtonToolbar className="modal__footer">

            <Button
              className="btn-lg button_enable "

              onClick={this.onLocation}
            >
              Proceed
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Failedtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
          {!this.state.force_reset && (
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff", marginRight: '10px' }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              skip
            </Button>)}
            {this.state.pswd_reset && (
              <Button
                style={{ backgroundColor: "#24d6a3", color: "#fff", marginLeft: '10px' }}
                className="modal_ok"
                onClick={() => window.location.href = '/password-reset'}>
                Change Password
              </Button>
            )}
          </ButtonToolbar>
        </Modal>


      </div>
    );
  }
}

export default reduxForm({
  form: "log_in_form", // a unique identifier for this form
})(LogInForm);
